import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="main-footer">
      <Container fluid>
        <Row>
          {/* Left Column - Company Info */}
          <Col lg={4} md={6} className="left-footer">
            <h5 className="text-golden">GoldenFast Network</h5>
            <p className="company-info">
              PT Jejaring Cepat Indonesia<br />
              Cyber Building 1, 3rd Floor<br />
              Jl.Kuningan Barat no.8<br />
              Jakarta 12710 - Indonesia<br />
              +62-21-5277822
            </p>

            <h5 className="text-golden">Contact Us</h5>
            <ul className="contact-list">
              <li>
                <i className="fas fa-phone"></i>
                <a href="tel:+622139737700">+62-21-39737700</a>
              </li>
              <li>
                <i className="fab fa-whatsapp"></i>
                <a href="https://api.whatsapp.com/send?phone=628112255386&text=Hello%20Goldenfast%20Network">
                  +628112255386
                </a>
              </li>
              <li>
                <i className="far fa-envelope"></i>
                <a href="mailto:sales@gfn.co.id">sales@gfn.co.id</a>
              </li>
              <li>
                <i className="far fa-clock"></i>
                24 X 7 x 365 Support Team
              </li>
              <li>
                <i className="fas fa-user-clock"></i>
                Realtime Staff Monitoring
              </li>
            </ul>

            <h5 className="text-golden">Layanan Kami</h5>
            <ul className="services-list">
              <li><a href="https://www.goldenfast.net/cloud-vps/">Cloud VPS</a></li>
              <li><a href="https://www.goldenfast.net/dedicated-server/">Dedicated Server</a></li>
              <li><a href="https://www.goldenfast.net/colocation-server/">Colocation Server</a></li>
              <li><a href="https://www.goldenfast.net/cross-connect/">Cross Connect</a></li>
              <li><a href="https://www.goldenfast.net/ftp-backup/">FTP Backup</a></li>
              <li><a href="https://www.goldenfast.net/offline-backup/">Offline Backup</a></li>
              <li><a href="https://www.goldenfast.net/licenses/">Licenses</a></li>
              <li><a href="https://www.goldenfast.net/manage-the-box/">Manage The Box</a></li>
            </ul>
          </Col>

          {/* Right Column - Company Description */}
          <Col lg={8} md={6} className="right-footer">
            <h2>GoldenFast Network: Jejaring Terpercaya Dari Indonesia</h2>
            <p className="company-description">
              GoldenFast Network (GFN) memberikan solusi data center terbaik untuk anda, 
              Dimulai pada September 2010 yang melayani Dedicated Server, Colocation Server, 
              dan Cloud Server. Golden Fast Network adalah penyedia layanan hosting dan server terpercaya 
              dan memiliki badan hukum sebagai PT Jejaring Cepat Indonesia
            </p>
            
            <Row className="features-grid">
              <Col md={6} className="feature-item">
                <h6><i className="fas fa-check"></i> Uptime Network diatas 98%</h6>
                <p>Uptime Network & Server di atas 98%. Didukung manajemen jaringan dan multiple upstream tier 1 provider network serta multiple peering.</p>
              </Col>
              <Col md={6} className="feature-item">
                <h6><i className="fas fa-check"></i> Private Data Center Tier 3</h6>
                <p>Goldenfast Network memiliki Data Center Private Tier 3 di Jakarta dengan full 24/7 monitoring Network Operation Center.</p>
              </Col>
              <Col md={6} className="feature-item">
                <h6><i className="fas fa-check"></i> High Grade Enterprise Hardware</h6>
                <p>Standar server Goldenfast Network adalah server kelas enterprise Dual Xeon Octa Core yang merupakan hardware kelas terbaik.</p>
              </Col>
              <Col md={6} className="feature-item">
                <h6><i className="fas fa-check"></i> Tier 1 Network</h6>
                <p>Tier 1 Network merupakan jaringan dunia tanpa transit network, yang membuat jaringan lebih cepat serta jalur routing yang lebih pendek.</p>
              </Col>
              <Col md={6} className="feature-item">
                <h6><i className="fas fa-check"></i> 24/7 Bantuan Customer Service</h6>
                <p>Technical Support & Customer Service Golden Fast Network siap membantu Anda selama 24 jam melalui layanan terpadu Live chat, Call Center, dan Support Ticket.</p>
              </Col>
              <Col md={6} className="feature-item">
                <div className="map-container">
                  <img 
                    src="https://www.goldenfast.net/wp-content/uploads/2019/08/map-indonesia-dot-10.png" 
                    alt="Indonesia Map" 
                    className="img-fluid"
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      
      {/* Copyright */}
      <div className="copyright">
        <Container fluid>
          <p>Copyright © 2025 GoldenFast Network.</p>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
